import AuthRoutes from './route-types.js'
import { isJwtLoginEnabled } from '@/services/featureFlags'
import { hasValidAuthToken } from '@/services/authToken'
import { resolveAppUrl } from './returnUrl'

/**
 * FQ-3057: while the JWT login flag is off, the legacy WebForms page is still the real
 * login and these routes must not render.
 *
 * The routes stay registered and redirect, rather than being registered conditionally:
 * an unregistered /login would resolve to nothing and paint a blank screen. Aborting the
 * navigation by assigning window.location without calling next() matches the existing
 * legacy-bounce idiom in router/index.js.
 *
 * The component is a dynamic import, so with the flag off its chunk is never fetched.
 */
function requireJwtLogin(legacyPage) {
  return (to, from, next) => {
    isJwtLoginEnabled().then(enabled => {
      if (!enabled) {
        window.location.href = `${process.env.VUE_APP_ROOT_URI}/${legacyPage}`
        return
      }
      // Already signed in - send them into the app instead of showing a login form, the way
      // SignIn.aspx did. Full navigation so App.vue bootstraps against the existing session.
      if (hasValidAuthToken()) {
        window.location.assign(resolveAppUrl(to.query.returnUrl))
        return
      }
      next()
    })
  }
}

const SignInView = () => import('./SignIn.vue')
const SignInCsrView = () => import('./SignInCsr.vue')
const ForgotPasswordView = () => import('./ForgotPassword.vue')
const ForgotPasswordCsrView = () => import('./ForgotPasswordCsr.vue')
const ResetPasswordView = () => import('./ResetPassword.vue')
const ForgotPasswordLogListView = () => import('./ForgotPasswordLogListView.vue')

const menuCode = 'A200'

export default [
  {
    path: AuthRoutes.SignInView.path,
    name: AuthRoutes.SignInView.name,
    component: SignInView,
    beforeEnter: requireJwtLogin('SignIn.aspx'),
    meta: { bypassAuth: true }
  },
  {
    path: AuthRoutes.SignInCsrView.path,
    name: AuthRoutes.SignInCsrView.name,
    component: SignInCsrView,
    beforeEnter: requireJwtLogin('SignInCsr.aspx'),
    meta: { bypassAuth: true }
  },
  {
    path: AuthRoutes.ForgotPasswordView.path,
    name: AuthRoutes.ForgotPasswordView.name,
    component: ForgotPasswordView,
    meta: { bypassAuth: true }
  },
  {
    path: AuthRoutes.ForgotPasswordCsrView.path,
    name: AuthRoutes.ForgotPasswordCsrView.name,
    component: ForgotPasswordCsrView,
    meta: { bypassAuth: true }
  },
  {
    path: AuthRoutes.ResetPasswordView.path,
    name: AuthRoutes.ResetPasswordView.name,
    component: ResetPasswordView,
    meta: { bypassAuth: true }
  },
  {
    path: AuthRoutes.ForgotPasswordLogListView.path,
    name: AuthRoutes.ForgotPasswordLogListView.name,
    component: ForgotPasswordLogListView,
    meta: {
      id: menuCode,
      route: 'listing',
      title: 'Forgot Password Log',
      name: 'Forgot Password Log'
    }
  }
]